import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box, CircularProgress, Typography,
} from '@mui/material';

import { empty, getToken, setToken } from './helpers/untils';

// Entry point that third-party apps redirect users to (documented to integrators
// as `${BASE_FRONT_URL}/oauth/authorize?...`, see OAuthAppApplicationTab). It only
// decides where the browser goes next — ensure the user is logged in, then hand
// off to the actual consent UI at /oauth/grant, carrying the same query string.
const OAuthAuthorizePage = () => {
  const history = useHistory();
  const isAdministrator = window.localStorage.getItem('isAdministrator') === '1'
  const isLoggedIn = !!getToken() && !isAdministrator;
  const [error, setError] = useState('');

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const response_type = params.get('response_type');
    const client_id = params.get('client_id');
    const redirect_uri = params.get('redirect_uri');

    if (response_type !== 'code' || empty(client_id) || empty(redirect_uri)) {
      setError('This authorization request is missing required parameters.');
      return;
    }

    const grantUrl = `/oauth/grant${search}`;
    if (!isLoggedIn) {
      if (isAdministrator) {
        //window.location.href = `/main`;
        setToken("");
        window.alert(`You're already logged in as administrator, however you must login as regular user!`);
        window.location.href = `/login?redirect_url=${encodeURIComponent(window.location.origin + grantUrl)}`;
        return;
      } else {
        window.location.href = `/login?redirect_url=${encodeURIComponent(window.location.origin + grantUrl)}`;
        return;
      }
    }

    history.replace(grantUrl);
  }, [isLoggedIn]);

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2,
    }}
    >
      {error ? <Typography color="error" align="center">{error}</Typography> : <CircularProgress />}
    </Box>
  );
};

export default OAuthAuthorizePage;
